export default __webpack_public_path__ + "static/media/avatar_arrow_boy4.ff79bfd7.mp3";